import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";
import { transition } from "../../utils/transition";
import { disabledState } from "../../theme/disabledState";

export const checkboxWrapperStyle = style({
  gap: theme.spacings.s,
});

export const checkboxStyle = recipe({
  base: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    flexGrow: 0,
    flexShrink: 0,
    borderRadius: theme.borderRadiuses.xxs,
    overflow: "hidden",
    transition: transition(
      "background-color",
      "color",
      "outline",
      "border-color",
    ),
    backgroundColor: theme.colors.background,
    color: theme.colors.background,
    border: `1px solid ${theme.colors.defaultBorder}`,
    selectors: {
      "&:not([aria-disabled])": {
        cursor: "pointer",
      },
      "&:not([aria-disabled]):hover": {
        // backgroundColor: `var(--background__hover, ${theme.colors.backgroundTint})`,
        borderColor: `var(--border__hover, ${theme.colors.primaryHover})`,
      },
      "&[data-active]:not([aria-disabled]):not(:hover)": {
        borderColor: `var(--border__hover, ${theme.colors.primaryHover})`,
        outlineColor: "transparent !important",
      },
    },
  },
  variants: {
    size: {
      s: {
        height: `${rem(18)} !important`,
        width: `${rem(18)} !important`,
      },
      m: {
        height: `${rem(24)} !important`,
        width: `${rem(24)} !important`,
      },
    },
    disabled: {
      true: {
        ...disabledState,
      },
    },
    checked: {
      true: {
        backgroundColor: `var(--background__checked, ${theme.colors.primary})`,
        borderColor: theme.colors.primary,
        vars: {
          "--background__hover": theme.colors.primaryHover,
          "--border__hover": theme.colors.primaryHover,
        },
      },
    },
    error: {
      true: {
        borderColor: theme.colors.error,
        color: theme.colors.onError,
        "--background__checked": theme.colors.error,
        vars: {
          "--background__hover": theme.colors.error,
          "--border__hover": theme.colors.error,
        },
        selectors: {
          "&[aria-checked]:not([aria-disabled])": {
            vars: {
              "--background__hover": theme.colors.errorHover,
              "--border__hover": theme.colors.errorHover,
            },
          },
        },
      },
    },
    success: {
      true: {
        borderColor: theme.colors.success,
        color: theme.colors.onSuccess,
        "--background__checked": theme.colors.success,
        vars: {
          "--background__hover": theme.colors.success,
          "--border__hover": theme.colors.success,
        },
        selectors: {
          "&[aria-checked]:not([aria-disabled])": {
            vars: {
              "--background__hover": theme.colors.successHover,
              "--border__hover": theme.colors.successHover,
            },
          },
        },
      },
    },
    highlight: {
      true: {
        borderColor: theme.colors.warning,
        color: theme.colors.onWarning,
        "--background__checked": theme.colors.warning,
        vars: {
          "--background__hover": theme.colors.warning,
          "--border__hover": theme.colors.warning,
        },
        selectors: {
          "&[aria-checked]:not([aria-disabled])": {
            vars: {
              "--background__hover": theme.colors.warningHover,
              "--border__hover": theme.colors.warningHover,
            },
          },
        },
      },
    },
  },
  defaultVariants: {
    size: "m",
  },
});

export const checkboxInputStyle = style({
  opacity: 0,
  position: "absolute",
  width: "100%",
  height: "100%",
  margin: 0,
  selectors: {
    "&:not([disabled])": {
      cursor: "pointer",
    },
    "&[disabled]": {
      cursor: "not-allowed",
    },
  },
});

export const checkStyle = recipe({
  base: {},
  variants: {
    checked: {
      true: {},
      false: {
        display: "none",
      },
    },
  },
});

export const labelStyle = recipe({
  base: { paddingTop: theme.spacings.xxs2 },
  variants: {
    disabled: {
      true: {
        ...disabledState,
      },
    },
  },
});
